import axios from "axios";

function getGroupAttributionProposals(routeParams = {}, data = {}, urlParams = {}) {
    return axios.get('api/v1/group-attribution-proposals', { params: urlParams });
}

function updateGroupAttributionProposalStatus({id}, data) {
    return axios.post(`api/v1/group-attribution-proposals/${id}/update-status`, data);
}

function getGroupAttributionProposalByHash({}, {}, {hash}) {
    return axios.get(`api/group-attribution-proposals/hash`, { params: { hash } });
}

function updateGroupAttributionProposalStatusByHash({}, data) {
    return axios.post(`api/group-attribution-proposals/update-status`, data);
}

function markGroupAttributionProposalAsRead({id}) {
    return axios.post(`api/v1/group-attribution-proposals/${id}/mark-read`);
}

export const groupAttributionProposalsService = {
    getGroupAttributionProposals,
    updateGroupAttributionProposalStatus,
    getGroupAttributionProposalByHash,
    updateGroupAttributionProposalStatusByHash,
    markGroupAttributionProposalAsRead
}; 